module.exports = __webpack_public_path__ + "static/img/jc03.6a3c6e6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/jc03.png
// module id = XuYM
// module chunks = 0